import React, { useEffect, useRef, useState } from 'react';
import { container } from 'tsyringe';
import { People } from '../../models/peopleClass';
import { PeopleService, PeopleKind } from '../../services/people-service';
import { PTApiService } from '../../services/ptapi-service';

import { WebRTCsdkService } from '../../services/webrtcsdk-service';
import useOnClickOutside from '../hooks/useOnClickOutside';
import LocalTime from '../utils/LocalTime';

import './PeopleMenu.scss';
import ExplainTips from '../utils/ExplainTips';
import { useNotTooFast } from '../hooks/useNotTooFast';

interface PeopleMenuProps {
  people: People
  onClose: any
  onRemove: any
  onChat?: any
  onDetails?: any
  onRename?: any
  fromProducer?: boolean
}

const PeopleMenu = (props: PeopleMenuProps) => {

  const { people, onClose, onRemove, onChat, onDetails, onRename } = props;

  const [isMenuVisible, setMenuVisible] = useState(false);
  const peopleMenu = useRef(undefined);


  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [peopleService] = useState(container.resolve(PeopleService));
  const [ptApiService] = useState(container.resolve(PTApiService));

  const [position, setPosition] = useState({ top: '25px', left: '215px' });

  const checkNotTooFast = useNotTooFast(400);

  const closeMenu = (force: boolean = false) => {
    console.log('setMenuVisible false 1');
    setMenuVisible(false);
    onClose();
  }

  const runMenuClose = () => {
    console.log('setMenuVisible false 2');
    closeMenu(false);
  }

  useOnClickOutside(peopleMenu, () => {
    runMenuClose();
  });

  const handleMuteMic = (ev) => {
    if (ev) ev.stopPropagation();
    if (checkNotTooFast()) {

      const audioMute = !people.audioMute;

      // mute a remote participant
      // ptApiService.setParticipantMute(people.endpointGUID, 'audio', audioMute, false);
      peopleService.setParticipantMute(people.endpointGUID, 'audio', audioMute, false);

      if (people.isSelf) {
        // this is ourSelf
        webRTCsdkService.setAudioMuted(audioMute);
      }
    }
  }
  const handleMuteVid = (ev) => {
    if (ev) ev.stopPropagation();

    if (checkNotTooFast()) {
      const videoMute = !people.videoMute;

      // mute a remote participant
      // ptApiService.setParticipantMute(people.endpointGUID, 'video', videoMute, false);
      peopleService.setParticipantMute(people.endpointGUID, 'video', videoMute, false);

      if (people.isSelf) {
        // this is ourSelf
        webRTCsdkService.setVideoMuted(videoMute);
      }
    }
  }
  const handleEnaDisMic = (ev) => {
    if (ev) ev.stopPropagation();

    if (checkNotTooFast()) {
      const audioHardMute = !people.audioHardMute;

      // mute a remote participant
      // ptApiService.setParticipantMute(people.endpointGUID, 'audio', audioHardMute, true);
      peopleService.setParticipantMute(people.endpointGUID, 'audio', audioHardMute, true);
    }
  }

  const handleEnaDisVid = (ev) => {
    if (ev) ev.stopPropagation();

    if (checkNotTooFast()) {
      const videoHardMute = !people.videoHardMute;

      // mute a remote participant
      // ptApiService.setParticipantMute(people.endpointGUID, 'video', videoHardMute, true);
      peopleService.setParticipantMute(people.endpointGUID, 'video', videoHardMute, true);
    }
  }

  const handleEditName = (ev) => {
    if (ev) ev.stopPropagation();
    if (onRename) {
      onRename();
    }
  }
  const handleRemovePeople = (ev) => {
    if (ev) ev.stopPropagation();
    if (onRemove) {
      onRemove();
    }
  }

  const handleCnxDetails = (ev) => {
    if (ev) ev.stopPropagation();
    if (onDetails) {
      onDetails()
    }
  }

  const handleNoiseCancel = (ev) => {
    if (ev) ev.stopPropagation();

    // mute a remote participant
    const newState = !people.voiceProcessing;
    // ptApiService.setVoiceProcessing(people.endpointGUID, newState);
    peopleService.setVoiceProcessing(people.endpointGUID, newState);
  }

  const handleChat = (ev) => {
    if (ev) ev.stopPropagation();
    if (onChat) {
      onChat()
    }
  }

  useEffect(() => {
    if (props.fromProducer) {
      setPosition({ top: '-10px', left: '45px' });
    }
  }, [])

  return (
    <>
      <div className="people-menu-container" onMouseLeave={() => console.log('closeMenu(true)')} ref={peopleMenu} style={{ top: position.top, left: position.left }}>
        <ul className="people-menu-container--ul">
          <li key='localtime' className="localtime">
            Local Time:&nbsp;&nbsp;&nbsp;<LocalTime timezone={people.timezone || ''} />
          </li>
          {people.role !== 'Attendee' ?
            <>
              <li key="mutemic" className={"picon " + (people.audioMute ? "pmic-muted" : "pmic-on")} onClick={(e) => handleMuteMic(e)}>{people.audioMute ? "Unmute Mic" : "Mute Mic"}</li>
              <li key="mutevid" className={"picon " + (people.videoMute ? "pvid-muted" : "pvid-on")} onClick={(e) => handleMuteVid(e)}>{people.videoMute ? "Unmute Video" : "Mute Video"}</li>
              <li key="endimic" className={"picon " + (people.audioHardMute ? "pmic-enable" : "pmic-disable")} onClick={(e) => handleEnaDisMic(e)}>{(people.audioHardMute ? 'Enable' : 'Disable') + 'Mic'}</li>
              <li key="endivid" className={"picon " + (people.videoHardMute ? "pvid-enable" : "pvid-disable")} onClick={(e) => handleEnaDisVid(e)}>{(people.videoHardMute ? 'Enable' : 'Disable') + 'Video'}</li>
              <li key="editname" className="picon pedit-name" onClick={(e) => handleEditName(e)}>Edit Name</li>
              {!people.isSelf && people.role !== 'Moderator' &&
                <li key="removeguest" className="picon pguest-remove" onClick={(e) => handleRemovePeople(e)}>{'Remove ' + (people.role == PeopleKind.ATTENDEE ? 'Attendee' : 'Presenter')}</li>
              }
              {!props.fromProducer &&
                <li key="cnxdetails" className="picon pcnx-details" onClick={(e) => handleCnxDetails(e)}>Connection Details</li>
              }
              <li key="noisecancel" className={"picon pnoise-cancel " + (people.voiceProcessing ? '' : 'disabled')} onClick={(e) => handleNoiseCancel(e)}>
                Noise Cancellation
                <ExplainTips text={'Disable Noise Cancellation<br/><br/>In case the event has a background music playing it is advised to disable noise cancellation, for a full event experience for your attendees.<br/><br/>Note: This action disables Dolby Voice'} tipStyle={{ top: '-8px', left: '5px' }} placement='bottom'></ExplainTips>
              </li>
            </>

            :

            <>
              <li key="chat" className="picon pchat" onClick={(e) => handleChat(e)}>Chat with Guest</li>
              <li key="removeguest" className="picon pguest-remove" onClick={(e) => handleRemovePeople(e)}>Remove Guest</li>
            </>
          }

        </ul>

      </div>

    </>
  );

}

export default PeopleMenu;